
import DaisoDialog from '~/components/common/modal/DaisoDialog.vue'
import CommonImage from '~/components/common/CommonImage.vue'

export default {
  components: {
    CommonImage,
    DaisoDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    serviceType: {
      type: String,
      default: '01'
    }
  },
  data () {
    return {
      titleData: {
        // 상품상세 배송칩 번호 기준으로 함
        '01': '휴일도착',
        '02': '매장픽업',
        '04': '대량주문',
        '05': '오늘배송'
      }
    }
  }
}
